export enum RecommedationTabs {
  Standard,
  TopTwelve,
  Enterprise,
  Mutual,
}
